import React from 'react';
const PleaseWaitLayer = () => {
    return (
        <>
            <div className="popup-wrapper">
                <img src={require("../assets/images/loading-gif.gif")}/>
            </div>
        </>
    )
}

export default PleaseWaitLayer